module.exports = __webpack_public_path__ + "img/img3.2ed96974.jpg";